let _ = t => t,
  _t,
  _t2,
  _t3;
import { match } from 'ts-pattern';
import { css } from 'styled-components';
import { colors } from '@ovpn-ui/styles';
const baseStyles = css(_t || (_t = _`
    text-decoration: underline;

    cursor: pointer;

    &[aria-disabled] {
        color: ${0};

        cursor: not-allowed;
    }
`), colors.neutralTextPlaceholder);
const primaryStyles = css(_t2 || (_t2 = _`
    ${0}

    color: ${0};

    &:hover:not([aria-disabled]) {
        color: ${0};
    }
`), baseStyles, colors.primaryBase, colors.primaryBaseHover);
const secondaryStyles = css(_t3 || (_t3 = _`
    ${0}

    color: ${0};

    &:hover:not([aria-disabled]) {
        color: ${0};
    }
`), baseStyles, colors.neutralTextSection, colors.neutralTextTitle);
export function matchLinkStyles(variant) {
  return match(variant).with('primary', () => primaryStyles).with('secondary', () => secondaryStyles).exhaustive();
}